import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const AgreementSVG = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.4444 0V1.77778H15.1173C15.6044 1.77778 16 2.17333 16 2.66044V16.8951C16 17.3822 15.6044 17.7778 15.1173 17.7778H0.882667C0.395556 17.7778 0 17.3822 0 16.8951V2.66044C0 2.17333 0.395556 1.77778 0.882667 1.77778H3.55556V0H12.4444ZM3.55556 3.55556H1.77778V16H14.2222V3.55556H12.4444V5.33333H3.55556V3.55556ZM5.33333 12.4444V14.2222H3.55556V12.4444H5.33333ZM5.33333 9.77778V11.5556H3.55556V9.77778H5.33333ZM5.33333 7.11111V8.88889H3.55556V7.11111H5.33333ZM10.6667 1.77778H5.33333V3.55556H10.6667V1.77778Z" />
  </svg>
);

const OrdersSVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M13.4707 0C13.9081 0 14.2631 0.354992 14.2631 0.792393V3.76941L12.6783 5.3542V1.58479H1.58479V14.2631H12.6783V12.0777L14.2631 10.4929V15.0555C14.2631 15.4929 13.9081 15.8479 13.4707 15.8479H0.792393C0.354992 15.8479 0 15.4929 0 15.0555V0.792393C0 0.354992 0.354992 0 0.792393 0H13.4707ZM14.8796 5.39461L16 6.51506L9.83677 12.6783L8.71474 12.6767L8.71632 11.5578L14.8796 5.39461V5.39461ZM7.92393 7.92393V9.50872H3.96197V7.92393H7.92393ZM10.3011 4.75436V6.33914H3.96197V4.75436H10.3011Z"
    />
  </svg>
);

const DashboardSVG = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M7.77778 14V6.22222H14V14H7.77778ZM0 7.77778V0H6.22222V7.77778H0ZM4.66667 6.22222V1.55556H1.55556V6.22222H4.66667ZM0 14V9.33333H6.22222V14H0ZM1.55556 12.4444H4.66667V10.8889H1.55556V12.4444ZM9.33333 12.4444H12.4444V7.77778H9.33333V12.4444ZM7.77778 0H14V4.66667H7.77778V0ZM9.33333 1.55556V3.11111H12.4444V1.55556H9.33333Z"
    />
  </svg>
);

const StatusSVG = () => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9999 1L11.5405 5.45946L9.51343 3.43243"
      stroke="#777777"
      strokeOpacity="0.8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.67568 3.43262H1"
      stroke="#777777"
      strokeOpacity="0.8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9999 8.70264L11.5405 13.1621L9.51343 11.1351"
      stroke="#777777"
      strokeOpacity="0.8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.67568 11.1353H1"
      stroke="#777777"
      strokeOpacity="0.8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ProfessionalSVG = () => (
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <path
        d="M11.9091 13.2725V11.9089C11.9091 11.1856 11.6218 10.4919 11.1103 9.98044C10.5988 9.46898 9.90514 9.18164 9.18182 9.18164H3.72727C3.00396 9.18164 2.31026 9.46898 1.7988 9.98044C1.28734 10.4919 1 11.1856 1 11.9089V13.2725"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.45457 6.45455C7.9608 6.45455 9.18184 5.2335 9.18184 3.72727C9.18184 2.22104 7.9608 1 6.45457 1C4.94834 1 3.72729 2.22104 3.72729 3.72727C3.72729 5.2335 4.94834 6.45455 6.45457 6.45455Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13.2728V11.9091C15.9996 11.3049 15.7985 10.7179 15.4282 10.2403C15.058 9.76268 14.5397 9.42158 13.9546 9.27051"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2273 1.08887C11.8139 1.23907 12.3339 1.58025 12.7052 2.05862C13.0765 2.53699 13.2781 3.12534 13.2781 3.73091C13.2781 4.33648 13.0765 4.92483 12.7052 5.4032C12.3339 5.88157 11.8139 6.22275 11.2273 6.37296"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const EditIconSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  >
    <path d="M18.311 2.828l2.861 2.861-15.033 15.032-2.859-2.862 15.031-15.031zm0-2.828l-16.873 16.872-1.438 7.127 7.127-1.437 16.873-16.873-5.689-5.689z" />
  </svg>
);

const RoleSVG = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.3333 2.66667H10.3333V1.33333C10.3333 0.598 9.73525 0 8.99992 0H4.99992C4.26459 0 3.66659 0.598 3.66659 1.33333V2.66667H1.66659C0.931252 2.66667 0.333252 3.26467 0.333252 4V11.3333C0.333252 12.0687 0.931252 12.6667 1.66659 12.6667H12.3333C13.0686 12.6667 13.6666 12.0687 13.6666 11.3333V4C13.6666 3.26467 13.0686 2.66667 12.3333 2.66667ZM9.99992 3.66658V11.6666H3.99992V3.66658H9.99992ZM9.33325 0.999919V2.66667H4.66659V0.999919H9.33325ZM1.33325 3.66658H2.99992V7.66658V11.6666H1.99992H1.33325V7.66658V3.66658ZM10.9999 11.6666V3.66658H12.6666V11.6666H10.9999Z" />
  </svg>
);

const LinkedinSVG = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.36917 4.646H7.84517V5.87933C8.20184 5.17 9.1165 4.53267 10.4905 4.53267C13.1245 4.53267 13.7498 5.94467 13.7498 8.53533V13.3333H11.0832V9.12533C11.0832 7.65 10.7265 6.818 9.8185 6.818C8.55917 6.818 8.03584 7.71467 8.03584 9.12467V13.3333H5.36917V4.646ZM0.796504 13.22H3.46317V4.53267H0.796504V13.22ZM3.84517 1.7C3.84527 1.92352 3.80094 2.14482 3.71476 2.35106C3.62858 2.55729 3.50227 2.74434 3.34317 2.90133C3.02077 3.22175 2.58438 3.4011 2.12984 3.4C1.6761 3.3997 1.24071 3.2208 0.917837 2.902C0.759311 2.74447 0.633428 2.55722 0.5474 2.35095C0.461372 2.14469 0.41689 1.92348 0.416504 1.7C0.416504 1.24867 0.596504 0.816667 0.918504 0.498C1.24109 0.178772 1.67666 -0.000199474 2.1305 1.66843e-07C2.58517 1.66843e-07 3.02117 0.179333 3.34317 0.498C3.6645 0.816667 3.84517 1.24867 3.84517 1.7Z"
      fill="#395FAC"
    />
  </svg>
);

const NoteSVG = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.9219 8H12.9375C12.8602 8 12.7969 8.06328 12.7969 8.14062V13.7656H1.26562V2.23438H6.89062C6.96797 2.23438 7.03125 2.17109 7.03125 2.09375V1.10938C7.03125 1.03203 6.96797 0.96875 6.89062 0.96875H0.5625C0.251367 0.96875 0 1.22012 0 1.53125V14.4688C0 14.7799 0.251367 15.0312 0.5625 15.0312H13.5C13.8111 15.0312 14.0625 14.7799 14.0625 14.4688V8.14062C14.0625 8.06328 13.9992 8 13.9219 8Z" />
    <path d="M4.28797 8.40254L4.25458 10.4926C4.25282 10.649 4.37938 10.7773 4.53583 10.7773H4.54286L6.61708 10.7264C6.65223 10.7246 6.68739 10.7105 6.712 10.6859L14.0227 3.39102C14.0772 3.33652 14.0772 3.24687 14.0227 3.19238L11.8378 1.00918C11.8097 0.981055 11.7745 0.96875 11.7376 0.96875C11.7007 0.96875 11.6655 0.982813 11.6374 1.00918L4.32841 8.3041C4.30302 8.33065 4.28858 8.36581 4.28797 8.40254ZM5.40419 8.81738L11.7376 2.49805L12.5321 3.29082L6.1952 9.61367L5.39188 9.63301L5.40419 8.81738Z" />
  </svg>
);

const MessageSVG = () => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.5 0.5H0.5C0.223437 0.5 0 0.723437 0 1V11C0 11.2766 0.223437 11.5 0.5 11.5H13.5C13.7766 11.5 14 11.2766 14 11V1C14 0.723437 13.7766 0.5 13.5 0.5ZM12.875 2.23125V10.375H1.125V2.23125L0.69375 1.89531L1.30781 1.10625L1.97656 1.62656H12.025L12.6938 1.10625L13.3078 1.89531L12.875 2.23125ZM12.025 1.625L7 5.53125L1.975 1.625L1.30625 1.10469L0.692188 1.89375L1.12344 2.22969L6.46094 6.37969C6.61444 6.49894 6.80328 6.56367 6.99766 6.56367C7.19203 6.56367 7.38088 6.49894 7.53438 6.37969L12.875 2.23125L13.3062 1.89531L12.6922 1.10625L12.025 1.625Z" />
  </svg>
);

const EducationSVG = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.6994 3.54104L8.19883 0.290802C8.07198 0.23583 7.92803 0.23583 7.80118 0.290802L0.30062 3.54104C-0.10016 3.71471 -0.100254 4.28497 0.30062 4.45864L2.99963 5.6282V8.75018C2.99963 10.4326 5.19605 11.7504 8 11.7504C10.804 11.7504 13.0004 10.4326 13.0004 8.75018V5.6282L13.5004 5.41153V10.7503C13.5004 11.0265 13.7243 11.2504 14.0004 11.2504C14.2766 11.2504 14.5005 11.0265 14.5005 10.7503V4.97818L15.6994 4.45867C16.1002 4.28501 16.1002 3.71474 15.6994 3.54104ZM8 1.29456L14.2429 3.99986L13.7478 4.21441L8.06201 3.50367C7.78796 3.46963 7.53806 3.6638 7.50381 3.93782C7.46956 4.21184 7.66395 4.46177 7.93797 4.49602L11.9427 4.99662L8 6.70512C4.47296 5.17673 5.22417 5.50225 1.75707 3.99983L8 1.29456ZM12.0003 8.75021C12.0003 9.22134 11.6136 9.70641 10.9394 10.081C9.3336 10.9731 6.67109 10.9757 5.06063 10.081C4.38639 9.70641 3.99971 9.22134 3.99971 8.75021V6.06161L7.80118 7.70892C7.92781 7.76379 8.07173 7.76398 8.19883 7.70892L12.0003 6.06161V8.75021Z" />
  </svg>
);

const WorkExpSVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.4375 9.517V7.1875H13.5938C13.8526 7.1875 14.0625 6.97763 14.0625 6.71875V3.90625C14.0625 2.95853 13.2915 2.1875 12.3438 2.1875H9.6875V1.40625C9.6875 0.630844 9.05666 0 8.28125 0H5.78125C5.00584 0 4.375 0.630844 4.375 1.40625V2.1875H1.71875C0.771031 2.1875 0 2.95853 0 3.90625V6.71875C0 6.97763 0.209875 7.1875 0.46875 7.1875H0.625V12.3438C0.625 12.6026 0.834875 12.8125 1.09375 12.8125H9.43894C9.48875 14.5786 10.9408 16 12.7188 16C14.528 16 16 14.528 16 12.7188C16 11.1563 14.9022 9.84563 13.4375 9.517ZM5.3125 1.40625C5.3125 1.14778 5.52278 0.9375 5.78125 0.9375H8.28125C8.53972 0.9375 8.75 1.14778 8.75 1.40625V2.1875H5.3125V1.40625ZM0.9375 6.25V3.90625C0.9375 3.47547 1.28797 3.125 1.71875 3.125H12.3438C12.7745 3.125 13.125 3.47547 13.125 3.90625V6.25H11.5625V5.78125C11.5625 5.52237 11.3526 5.3125 11.0938 5.3125H9.21875C8.95987 5.3125 8.75 5.52237 8.75 5.78125V6.25H5.3125V5.78125C5.3125 5.52237 5.10263 5.3125 4.84375 5.3125H2.96875C2.70987 5.3125 2.5 5.52237 2.5 5.78125V6.25H0.9375ZM10.625 6.25V7.1875H9.6875V6.25H10.625ZM4.375 6.25V7.1875H3.4375V6.25H4.375ZM1.5625 11.875V7.1875H2.5V7.65625C2.5 7.91513 2.70987 8.125 2.96875 8.125H4.84375C5.10263 8.125 5.3125 7.91513 5.3125 7.65625V7.1875H8.75V7.65625C8.75 7.91513 8.95987 8.125 9.21875 8.125H11.0938C11.3526 8.125 11.5625 7.91513 11.5625 7.65625V7.1875H12.5V9.44497C11.0792 9.53897 9.90288 10.5412 9.54769 11.875H1.5625ZM12.7188 15.0625C11.4264 15.0625 10.375 14.0111 10.375 12.7188C10.375 11.4264 11.4264 10.375 12.7188 10.375C14.0111 10.375 15.0625 11.4264 15.0625 12.7188C15.0625 14.0111 14.0111 15.0625 12.7188 15.0625Z" />
  </svg>
);

const LocationSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path d="M12 10c-1.104 0-2-.896-2-2s.896-2 2-2 2 .896 2 2-.896 2-2 2m0-5c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3m-7 2.602c0-3.517 3.271-6.602 7-6.602s7 3.085 7 6.602c0 3.455-2.563 7.543-7 14.527-4.489-7.073-7-11.072-7-14.527m7-7.602c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602" />
  </svg>
);

const SparkSVG = () => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1.5L2.09347 12.1879C1.74466 12.6064 1.57026 12.8157 1.56759 12.9925C1.56528 13.1461 1.63375 13.2923 1.75327 13.3889C1.89076 13.5 2.16319 13.5 2.70805 13.5H10L9.00001 21.5L17.9066 10.8121C18.2554 10.3936 18.4298 10.1843 18.4324 10.0075C18.4348 9.85388 18.3663 9.7077 18.2468 9.61111C18.1093 9.5 17.8368 9.5 17.292 9.5H10L11 1.5Z"
      stroke="#1570EF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
const PinSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 0c-6.627 0-12 5.372-12 12 0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146 1.124.347 2.317.535 3.554.535 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
  </svg>
);

const StackoverflowSVG = () => (
  <svg
    width="18px"
    height="18px"
    viewBox="-5 0 48 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icons"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Color-" transform="translate(-807.000000, -952.000000)">
        <g id="stackoverflow" transform="translate(807.000000, 952.000000)">
          <path
            d="M25.0860128,41.5922927 L5.97459514,41.6011499 L5.97294973,37.5538824 L25.0835447,37.5440929 L25.0860128,41.5922927 L25.0860128,41.5922927 Z M38,18.6708298 L34.7306912,0 L30.7087256,0.692025863 L33.9775643,19.3628557 L38,18.6708298 L38,18.6708298 Z M25.5455518,32.3547147 L6.51569942,30.616026 L6.14101644,34.6470941 L25.1712214,36.3841513 L25.5455518,32.3547147 L25.5455518,32.3547147 Z M26.8009984,27.0731519 L8.34598112,22.1539179 L7.28563299,26.0621508 L25.7419431,30.9819676 L26.8009984,27.0731519 L26.8009984,27.0731519 Z M29.2103463,22.4436411 L12.7494464,12.8164635 L10.6748215,16.3015328 L27.1365441,25.9292931 L29.2103463,22.4436411 L29.2103463,22.4436411 Z M33.2466504,19.6088756 L22.4792159,3.95170309 L19.106599,6.23184556 L29.8745036,21.8883189 L33.2466504,19.6088756 L33.2466504,19.6088756 Z"
            fill="#FF810F"
          ></path>
          <polygon
            id="stackoverflow-icon-path"
            fill="#BEBCBC"
            points="28.3315807 28.2784283 28.3315807 44.8243495 3.2648427 44.8243495 3.2648427 28.2784283 0 28.2784283 0 48 31.5799693 48 31.5799693 28.2784283"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
);
const ArtstationSVG = () => (
  <svg
    height="18"
    version="1.1"
    viewBox="0 0 512 512"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="_x32_7-artstation">
      <g>
        <path d="M26,365.896l38.925,67.261c7.695,15.208,23.354,25.617,41.55,25.617h258.357l-53.591-92.878H26z     M478.44,341.094L327.989,77.938c-7.785-14.664-23.265-24.713-41.099-24.713h-80.023l232.919,405.186l36.843-63.818    C478.35,391.697,495.64,367.706,478.44,341.094z M273.131,299.903L168.576,118.856L64.02,299.903H273.131z" />
      </g>
    </g>
    <g id="Layer_1" />
  </svg>
);

const BehanceSVG = () => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 -9 48 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icons"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Color-"
        transform="translate(-700.000000, -169.000000)"
        fill="#1769FF"
      >
        <path
          d="M730.671768,174.006032 L743.382997,174.006032 L743.382997,170.364269 L730.671768,170.364269 L730.671768,174.006032 L730.671768,174.006032 Z M733.683065,181.952204 C732.873091,182.776334 732.362271,183.892807 732.153427,185.301624 L742.039626,185.301624 C741.935204,183.798144 741.421562,182.662181 740.51281,181.879814 C739.59277,181.103016 738.461064,180.716009 737.106404,180.716009 C735.638855,180.716009 734.493039,181.128074 733.683065,181.952204 L733.683065,181.952204 L733.683065,181.952204 Z M742.26258,177.063109 C743.79504,177.736891 745.056567,178.806032 746.049985,180.264965 C746.955914,181.551276 747.537289,183.043619 747.802576,184.739211 C747.957798,185.730394 748.019886,187.167053 747.994487,189.035267 L732.012317,189.035267 C732.108272,191.204176 732.864624,192.727146 734.309595,193.598608 C735.18448,194.141531 736.237164,194.414385 737.473291,194.414385 C738.77433,194.414385 739.838302,194.083063 740.653921,193.423202 C741.102652,193.064037 741.497761,192.568445 741.836426,191.933643 L747.69251,191.933643 C747.537289,193.214385 746.826092,194.520186 745.567387,195.845476 C743.603129,197.947564 740.851476,199 737.315248,199 C734.394261,199 731.817584,198.114617 729.590862,196.338283 C727.35285,194.564733 726.240899,191.67471 726.240899,187.676566 C726.240899,183.926218 727.248428,181.050116 729.260663,179.04826 C731.278543,177.051972 733.889086,176.046868 737.103582,176.046868 C739.014217,176.046868 740.732943,176.386543 742.26258,177.063109 L742.26258,177.063109 L742.26258,177.063109 Z M705.912528,185.379582 L705.912528,193.183759 L713.114805,193.183759 C714.401733,193.183759 715.406439,193.011137 716.120458,192.668677 C717.421496,192.028306 718.070604,190.814385 718.070604,189.015777 C718.070604,187.490023 717.444074,186.44594 716.182546,185.875174 C715.476994,185.557773 714.486399,185.390719 713.216405,185.379582 L705.912528,185.379582 L705.912528,185.379582 Z M705.912528,174.081206 L705.912528,180.537819 L713.126094,180.537819 C714.410199,180.537819 715.457239,180.295592 716.264391,179.811137 C717.065898,179.326682 717.469474,178.469142 717.469474,177.244084 C717.469474,175.87703 716.938899,174.977726 715.877748,174.537819 C714.957708,174.234339 713.789313,174.081206 712.369742,174.081206 L705.912528,174.081206 L705.912528,174.081206 Z M722.021697,172.118329 C722.927626,173.362877 723.382002,174.849652 723.382002,176.584223 C723.382002,178.36891 722.927626,179.808353 722.010408,180.8942 C721.496766,181.50116 720.743236,182.058005 719.746996,182.559165 C721.259701,183.104872 722.399873,183.965197 723.17598,185.142923 C723.943621,186.317865 724.330264,187.748956 724.330264,189.430626 C724.330264,191.165197 723.889999,192.721578 723.006648,194.096984 C722.447851,195.007425 721.747943,195.77587 720.906924,196.399536 C719.961484,197.115081 718.846712,197.60232 717.556962,197.869606 C716.267213,198.134107 714.873042,198.262181 713.365982,198.262181 L700,198.262181 L700,169 L714.334,169 C717.952072,169.0529 720.511815,170.091415 722.021697,172.118329 L722.021697,172.118329 L722.021697,172.118329 Z"
          id="Behance"
        ></path>
      </g>
    </g>
  </svg>
);

const RedditSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    <path d="M24 11.779c0-1.459-1.192-2.645-2.657-2.645-.715 0-1.363.286-1.84.746-1.81-1.191-4.259-1.949-6.971-2.046l1.483-4.669 4.016.941-.006.058c0 1.193.975 2.163 2.174 2.163 1.198 0 2.172-.97 2.172-2.163s-.975-2.164-2.172-2.164c-.92 0-1.704.574-2.021 1.379l-4.329-1.015c-.189-.046-.381.063-.44.249l-1.654 5.207c-2.838.034-5.409.798-7.3 2.025-.474-.438-1.103-.712-1.799-.712-1.465 0-2.656 1.187-2.656 2.646 0 .97.533 1.811 1.317 2.271-.052.282-.086.567-.086.857 0 3.911 4.808 7.093 10.719 7.093s10.72-3.182 10.72-7.093c0-.274-.029-.544-.075-.81.832-.447 1.405-1.312 1.405-2.318zm-17.224 1.816c0-.868.71-1.575 1.582-1.575.872 0 1.581.707 1.581 1.575s-.709 1.574-1.581 1.574-1.582-.706-1.582-1.574zm9.061 4.669c-.797.793-2.048 1.179-3.824 1.179l-.013-.003-.013.003c-1.777 0-3.028-.386-3.824-1.179-.145-.144-.145-.379 0-.523.145-.145.381-.145.526 0 .65.647 1.729.961 3.298.961l.013.003.013-.003c1.569 0 2.648-.315 3.298-.962.145-.145.381-.144.526 0 .145.145.145.379 0 .524zm-.189-3.095c-.872 0-1.581-.706-1.581-1.574 0-.868.709-1.575 1.581-1.575s1.581.707 1.581 1.575-.709 1.574-1.581 1.574z" />
  </svg>
);

const TiktokSVG = () => (
  <svg
    width={18}
    height={18}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2859 3333"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    image-rendering="optimizeQuality"
    fill-rule="evenodd"
    clip-rule="evenodd"
  >
    <path d="M2081 0c55 473 319 755 778 785v532c-266 26-499-61-770-225v995c0 1264-1378 1659-1932 753-356-583-138-1606 1004-1647v561c-87 14-180 36-265 65-254 86-398 247-358 531 77 544 1075 705 992-358V1h551z" />
  </svg>
);

const DribbbleSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    <path d="M12 0c-6.628 0-12 5.373-12 12s5.372 12 12 12 12-5.373 12-12-5.372-12-12-12zm9.885 11.441c-2.575-.422-4.943-.445-7.103-.073-.244-.563-.497-1.125-.767-1.68 2.31-1 4.165-2.358 5.548-4.082 1.35 1.594 2.197 3.619 2.322 5.835zm-3.842-7.282c-1.205 1.554-2.868 2.783-4.986 3.68-1.016-1.861-2.178-3.676-3.488-5.438.779-.197 1.591-.314 2.431-.314 2.275 0 4.368.779 6.043 2.072zm-10.516-.993c1.331 1.742 2.511 3.538 3.537 5.381-2.43.715-5.331 1.082-8.684 1.105.692-2.835 2.601-5.193 5.147-6.486zm-5.44 8.834l.013-.256c3.849-.005 7.169-.448 9.95-1.322.233.475.456.952.67 1.432-3.38 1.057-6.165 3.222-8.337 6.48-1.432-1.719-2.296-3.927-2.296-6.334zm3.829 7.81c1.969-3.088 4.482-5.098 7.598-6.027.928 2.42 1.609 4.91 2.043 7.46-3.349 1.291-6.953.666-9.641-1.433zm11.586.43c-.438-2.353-1.08-4.653-1.92-6.897 1.876-.265 3.94-.196 6.199.196-.437 2.786-2.028 5.192-4.279 6.701z" />
  </svg>
);

const TumblrSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-1.105 18.739c-.524.691-2.29 1.261-3.889 1.261-3.979 0-6.006-1.466-6.006-4.573v-4.104h-1.933l-.067-.067v-3.16l.045-.064.178-.059c1.597-.534 2.624-1.432 2.851-3.284.055-.447.431-.689.757-.689h4.767l.066.067v3.211l.066.067h2.535l.068.067v3.844l-.068.067h-2.545l-.067.067v3.81c.002.103.006.414.109.414h2.182l.064.046.992 2.941-.105.138zm-1.309-2.278l.664 1.967-.016.07c-.5.48-1.703.837-2.686.854l-.111.001c-3.232 0-3.788-2.468-3.788-3.926v-4.692l-.066-.067h-1.854l-.067-.067-.016-2.041.042-.062c1.67-.65 2.604-1.73 2.849-3.729.014-.111.105-.114.106-.114h2.298l.067.067v3.211l.068.067h2.535l.066.067v2.534l-.066.067h-2.547l-.064.067v4.47c.016.959.477 1.445 1.377 1.445.362 0 .744-.084 1.123-.229l.086.04z" />
  </svg>
);

const PinterestSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 0c-6.627 0-12 5.372-12 12 0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146 1.124.347 2.317.535 3.554.535 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
  </svg>
);

const PenupSVG = () => (
  <svg
    width="18"
    height="18"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
  >
    <g fill="none" fill-rule="evenodd">
      <path
        d="M23.471 28.69a.798.798 0 0 0-.75.377L20.5 32.665l-2.221-3.598a.798.798 0 0 0-.75-.378l-7.395.668 8.358-17.488h4.016l8.358 17.488-7.395-.668zm9.45 1.247l-11.7-24.48A.8.8 0 0 0 20.5 5a.8.8 0 0 0-.72.457l-11.7 24.48a.815.815 0 0 0 .062.811.8.8 0 0 0 .73.345l8.31-.75 2.64 4.276a.798.798 0 0 0 1.357 0l2.64-4.276 8.31.75a.8.8 0 0 0 .729-.345.815.815 0 0 0 .062-.811z"
        fill="#000"
      />
      <path d="M0 0h40v40H0z" />
    </g>
  </svg>
);

const DeviantartSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    <path d="M20 4.364v-4.364h-4.364l-.435.439-2.179 4.124-.647.437h-7.375v6h4.103l.359.404-4.462 8.232v4.364h4.509l.435-.439 2.174-4.124.648-.437h7.234v-6h-3.938l-.359-.438z" />
  </svg>
);

const UpworkSVG = () => (
  <svg
    id="Layer_1"
    width="18"
    height="18"
    version="1.1"
    viewBox="0 0 56.7 56.7"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      style={{ fill: "#4fab4a " }}
      d="M42.4,17.7c-5.3,0-9.3,3.5-10.9,9c-2.5-3.9-4.5-8.3-5.6-12.1h-5.6v14.7c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3V14.7  H4.3v14.7c0,6.1,4.9,11,10.9,11c6,0,10.9-4.9,10.9-11v-2.5c1.1,2.2,2.5,4.6,4,6.7l-3.5,16.3h5.7L34.7,38c2.2,1.4,4.7,2.2,7.7,2.2  c6.1,0,11.1-5,11.1-11.4C53.5,22.7,48.5,17.7,42.4,17.7z M42.4,34.6c-2.2,0-4.5-1-6.3-2.5l0.6-2.2v-0.1c0.4-2.4,1.7-6.4,5.8-6.4  c3.1,0,5.6,2.5,5.6,5.6C48,32.1,45.3,34.6,42.4,34.6z"
    />
  </svg>
);

const FiverSVG = () => (
  <svg
    width="18"
    height="18"
    version="1.1"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="_x31_29-fiverr">
      <g>
        <g>
          <path
            d="M413.696,399.751V169.75H184.32v-14.375c0-23.779,19.295-43.124,43.004-43.124h43.008v-86.25     h-43.008c-71.134,0-129.019,58.044-129.019,129.374v14.375H40.962V256h57.342v143.751H40.962v86.248h200.705v-86.248H184.32V256     h144.157v143.751h-58.145v86.248h200.705v-86.248H413.696z"
            style={{ fill: "#1DBF73" }}
          />
          <path
            d="M370.685,112.251c23.751,0,43.012-19.306,43.012-43.125c0-23.821-19.261-43.125-43.012-43.124     c-23.749,0-43.005,19.303-43.005,43.124C327.68,92.945,346.936,112.251,370.685,112.251z"
            style={{ fill: "#1DBF73" }}
          />
        </g>
      </g>
    </g>
    <g id="Layer_1" />
  </svg>
);

const CBSVG = () => (
  <svg
    fill="#000000"
    width="18px"
    height="18px"
    viewBox="0 0 24 24"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21.6 0H2.4A2.41 2.41 0 0 0 0 2.4v19.2A2.41 2.41 0 0 0 2.4 24h19.2a2.41 2.41 0 0 0 2.4-2.4V2.4A2.41 2.41 0 0 0 21.6 0zM7.045 14.465A2.11 2.11 0 0 0 9.84 13.42h1.66a3.69 3.69 0 1 1 0-1.75H9.84a2.11 2.11 0 1 0-2.795 2.795zm11.345.845a3.55 3.55 0 0 1-1.06.63 3.68 3.68 0 0 1-3.39-.38v.38h-1.51V5.37h1.5v4.11a3.74 3.74 0 0 1 1.8-.63H16a3.67 3.67 0 0 1 2.39 6.46zm-.223-2.766a2.104 2.104 0 1 1-4.207 0 2.104 2.104 0 0 1 4.207 0z" />
  </svg>
);

const GmailSVG = () => (
  <svg
    width="48"
    height="36"
    viewBox="0 0 48 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="35.9537" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_7077_124922"
          transform="scale(0.003861 0.00515464)"
        />
      </pattern>
      <image
        id="image0_7077_124922"
        width="259"
        height="194"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

const OutLookSvg = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23 23"
      width={23}
      height={23}
    >
      <path fill="#f3f3f3" d="M0 0h23v23H0z" />
      <path fill="#f35325" d="M1 1h10v10H1z" />
      <path fill="#81bc06" d="M12 1h10v10H12z" />
      <path fill="#05a6f0" d="M1 12h10v10H1z" />
      <path fill="#ffba08" d="M12 12h10v10H12z" />
    </svg>
  );
};

const CheckMarkSolidOutlineSVG = () => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_7620_42418)">
      <rect width="24" height="24" rx="12" fill="#1570EF" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.096 7.39016L9.93602 14.3002L8.03602 12.2702C7.68602 11.9402 7.13602 11.9202 6.73602 12.2002C6.34602 12.4902 6.23602 13.0002 6.47602 13.4102L8.72602 17.0702C8.94602 17.4102 9.32601 17.6202 9.75601 17.6202C10.166 17.6202 10.556 17.4102 10.776 17.0702C11.136 16.6002 18.006 8.41016 18.006 8.41016C18.906 7.49016 17.816 6.68016 17.096 7.38016V7.39016Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_7620_42418">
        <rect width="24" height="24" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UpworkIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={UpworkSVG} {...props} />
);

export const FiverIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FiverSVG} {...props} />
);

const CyberbgSVG = () => (
  <img src="../../../../cyberbg.png" alt="" width={18} />
);

const ThatsthemSVG = () => (
  <img src="../../../../thatsthem.png" alt="" width={18} />
);

const CgSVG = () => <img src="../../../../cg.png" alt="" width={18} />;

export const AgreementIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={AgreementSVG} {...props} />
);

export const OrderIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={OrdersSVG} {...props} />
);

export const DashboardIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DashboardSVG} {...props} />
);

export const StatusIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={StatusSVG} {...props} />
);

export const ProfessionalIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ProfessionalSVG} {...props} />
);

export const EditIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EditIconSVG} {...props} />
);

export const RoleIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={RoleSVG} {...props} />
);

export const LinkedinIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LinkedinSVG} {...props} />
);

export const NoteIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={NoteSVG} {...props} />
);

export const MessageIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MessageSVG} {...props} />
);
export const EducationIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EducationSVG} {...props} />
);

export const WorkExpIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={WorkExpSVG} {...props} />
);

export const LocationIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LocationSVG} {...props} />
);

export const SparkSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SparkSVG} {...props} />
);

export const PinSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PinSVG} {...props} />
);

export const GmailIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={GmailSVG} {...props} />
);

export const StackoverflowSVGIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={StackoverflowSVG} {...props} />;

export const ArtstationSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ArtstationSVG} {...props} />
);

export const BehanceSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BehanceSVG} {...props} />
);

export const RedditSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={RedditSVG} {...props} />
);

export const TiktokSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TiktokSVG} {...props} />
);

export const DribbbleSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DribbbleSVG} {...props} />
);

export const TumblrSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TumblrSVG} {...props} />
);

export const PinterestSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PinterestSVG} {...props} />
);

export const PenupSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PenupSVG} {...props} />
);

export const DeviantartSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DeviantartSVG} {...props} />
);

export const CyberbgSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CyberbgSVG} {...props} />
);

export const ThatsthemSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ThatsthemSVG} {...props} />
);

export const CgSVGIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CgSVG} {...props} />
);

export const CBIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CBSVG} {...props} />
);

export const CheckMarkIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CheckMarkSolidOutlineSVG} {...props} />
);
export const OutLookSvgIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={OutLookSvg} {...props} />
);
